import { RouterMap } from '../../types';

export const routeMap: RouterMap = new Map();

routeMap.set('/basicData/customerManagement', {
  name: 'CustomerManagement',
});
routeMap.set('/basicData/warehouseManagement', {
  name: 'WarehouseManagement',
});
routeMap.set('/basicData/accessoriesManagement', {
  name: 'AccessoriesManagement',
});
